module.exports = __webpack_public_path__ + "static/media/img6.1e840297.jpg";